<template>
  <v-window class="mb-4">
    <v-img src="/image/legal/terms-of-use.jpg" id="landing-section">
      <v-layout row style="height: 100%">
        <v-layout align-center justify-center>
          <v-flex xs12>
            <v-card color="transparent" flat>
              <v-card-text>
                <h3 id="slogan" class="text-xs-center white--text text-shadow">
                  TÉRMINOS Y CONDICIONES DE USO
                </h3>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-img>

    <template>
      <div v-waypoint="{ active: true, callback: onWaypoint }"></div>
    </template>

    <v-container>
      <h1 class="mt-5 primary--text">Estructura del documento</h1>
      <ul>
        <dl>a) Definiciones.</dl>
        <dl>b) Condiciones generales.</dl>
        <dl>c) Anexo de servicios y condiciones de uso.</dl>
      </ul>
      <h1 class="mt-5 primary--text">Definiciones.</h1>
      <p class="mb-0">
        Con excepción de los nombres propios y de la palabra inicial de
        cualquier frase, los términos con mayúscula inicial que se usan en este
        instrumento y que no hayan sido definidos especialmente en el mismo,
        tendrán para todos los efectos de este instrumento, en cada caso, el
        significado que para cada uno de ellos se pasa a indicar, siendo
        extensivas tales definiciones tanto a su forma en singular o plural,
        según sea el caso:
      </p>
      <ul>
        <li>
          <b>Usuario:</b> persona que se ha registrado, convirtiéndose en
          cliente de la empresa Wesmartpark Chile SpA, RUT N° 76.743.992-k (en
          adelante indistintamente “WSP Chile”, o “WSP” o “Wesmartpark”), y que
          utiliza el Servicio WeSmartPark para estacionar de acuerdo con las
          presentes condiciones de uso.
        </li>
        <li>
          <b>Servicio</b> WeSmartPark: servicio de aparcamiento en los
          Estacionamientos ofrecidas por WSP y utilizado por los Usuarios.
        </li>
        <li>
          <b>Propietario:</b> dueño de una o más plazas de aparcamiento o
          Estacionamientos ofrecidos a los Usuarios mediante el Servicio
          WeSmartPark.
        </li>
        <li>
          <b>Estacionamientos:</b> plazas de aparcamiento o estacionamiento de
          los Propietarios ofrecidas a los Usuarios mediante el Servicio
          WeSmartPark.
        </li>
        <li>
          <b>Perfil:</b> espacio habilitado por WSP Chile en el Servidor
          WeSmartPark, que contiene los datos proporcionados por los Usuarios y
          Propietarios, en el que éstos pueden guardarlos, consultarlos y
          modificarlos; así como interactuar, participar, y contratar en el
          Servicio WeSmartPark.
        </li>
        <li>
          <b>Servidor/es WeSmartPark:</b> hosting en que está alojado el sistema
          para prestar el Servicio WeSmartPark a Usuarios, y Propietarios,
          disponible mediante la aplicación para aparatos de telefonía celular
          denominada Wesmartpark, la cual puede bajarse por los Usuarios para
          las plataformas IOS y Android y disponible en sitio web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >.
        </li>
        <li>
          <b>Nombre de Usuario:</b> dirección de correo electrónico que tanto
          Usuario como Propietario facilitan para poder registrarse para
          utilizar el Servicio WeSmartPark y que les servirá para acceder a sus
          distintos perfiles y poder utilizarlos. Los nombres de Usuario no
          pueden repetirse, por lo que cada nombre de Usuario deberá
          corresponder a un Perfil determinado.
        </li>
        <li>
          <b>Contraseña:</b> clave que tanto Usuario como Propietario facilitan
          para poder registrarse en el Servicio WeSmartPark y que les servirá
          para acceder a sus distintos perfiles y poder utilizar el Servicio
          WeSmartPark.
        </li>
        <li>
          <b>Sticker de acceso o StickerTag:</b> etiqueta adhesiva que contiene
          un chip RFID con los datos del Usuario. Su finalidad es permitir y
          registrar la entrada y salida de un vehículo a los sitios en donde se
          encuentran ubicados los Estacionamientos; esta etiqueta adhesiva se
          debe colocar en el parabrisas del vehículo de acuerdo con las
          instrucciones que WSP Chile le proporcionará al Usuario al momento de
          su entrega.
        </li>
        <li>
          <b>Bluetooth / BLE:</b> sistema de ingreso a través de la tecnología
          Bluetooth de cada móvil que se comunica con nuestros dispositivos BLE
          (bluetooh low energy) instalados en los accesos de cada edificio
          (tanto peatonal como vehicular). Su finalidad es permitir y registrar
          la entrada y salida de un vehículo a los sitios en donde se encuentran
          ubicados los Estacionamientos.
        </li>
        <li>
          <b>Unidad de Control:</b> equipo electrónico consistente, básicamente,
          en una pantalla táctil y un lector de etiquetas cuya función es ayudar
          e interactuar con el Usuario durante su estancia en el interior del
          espacio en donde se ubican los Estacionamientos, especialmente
          programada para indicarle la plaza que debe ocupar.
        </li>
        <li>
          <b>Teclado Numérico:</b> teclado que permite el acceso a pie al
          Usuario en algunos de los recintos en que están ubicados los
          Estacionamientos. El Usuario deberá introducir su número de móvil (9
          dígitos) para que se abra el control de acceso al recinto en donde se
          ubican los Estacionamientos.
        </li>
        <li>
          <b>Ocupación:</b> espacio de tiempo durante el cual el vehículo del
          Usuario permanece estacionado en una plaza de la red del Servicio
          WeSmartPark.
        </li>
        <li>
          <b>Disponibilidad:</b> espacio de tiempo que el Propietario indica que
          él o los Estacionamientos pueden utilizarse por los Usuarios.
        </li>
        <li>
          <b>Tiempo de Anticipación:</b> período temporal de 30 minutos,
          anterior al Horario de Reserva, que el Servicio WeSmartPark contempla
          para que el Usuario pueda entrar antes de la hora que ha indicado como
          inicio de su Reserva.
        </li>
        <li>
          <b>Horario de Reserva:</b> corresponde al momento en que el Usuario ha
          realizado una reserva de Estacionamiento.
        </li>
        <li>
          <b>Reserva:</b> corresponde a la reserva realizada por un Usuario de
          un Estacionamiento, en la que se indica el horario en que el Usuario
          comenzará a hacer uso de un Estacionamiento, uso que podrá tener un
          Tiempo Límite.
        </li>
        <li>
          <b>Tiempo Extra:</b> espacio de tiempo que se inicia pasados 30
          minutos del Tiempo Límite de Estacionamiento, si es que la hubiera. El
          tiempo adicional en que Usuario utilice uno o más Estacionamientos que
          supere el Tiempo Límite se cobrará de acuerdo a una tarifa ascendente
          a al doble del valor por minuto informado en la app (IVA incluido). En
          el caso de que uno o más Estacionamientos estuvieran sujetos a Tiempo
          Límite, esta situación se le indicará al Usuario durante el proceso de
          aceptación de la reserva.
        </li>
        <li>
          <b>Tiempo Límite:</b> Es el tiempo u horario límite hasta el cual
          puede utilizarse un Estacionamiento y que se le informará al Usuario
          al momento de realizar la Reserva, para que éste tome los recaudos del
          caso.
        </li>
        <li>
          <b>Recarga de Saldo:</b> es el espacio habilitado por WSP Chile en el
          Perfil de Usuario, a fin de que éste pueda recargar su saldo online
          mediante el uso de tarjeta de crédito o débito (para esto se utiliza
          plataforma ONE CLICK o WEBPAY de Transbank) para el uso del Servicio
          WeSmartPark; y donde puede visualizar su estado y consumo. El saldo
          comprado por los conductores no caduca.
        </li>
        <li>
          <b>Saldo:</b> Es el monto en pesos ($) disponible de cada Usuario al
          momento de la consulta en los Servidores Wesmartpark, y que refleja el
          monto en pesos ($) disponible para ser utilizado en la modalidad de
          reservas por minuto por el Usuario en Servicios Wesmartpark. Se deja
          constancia que el saldo en pesos inicial cargado por WSP al Usuario
          correspondiente a $3.000 tendrá una duración de tres meses desde la
          activación del StickerTag. El Saldo sólo podrá ser cargado mediante
          tarjeta de crédito o débito incorporada en el sistema de pago en el
          Perfil del Usuario, para lo cual se utiliza la plataforma ONECLICK o
          WEBPAY de Transbank.
        </li>
      </ul>
      <h1 class="mt-5 primary--text">Condiciones generales.</h1>
      <p>
        El presente instrumento relativo a los términos y condiciones generales
        de uso que regulan el uso de la aplicación para aparatos de telefonía
        celular denominada Wesmartpark y del sitio web
        <a href="https://www.wesmartpark.com" target="blank"
          >https://ww.wesmartpark.com</a
        >, ya sea con su actual nombre o con cualquier otra denominación con la
        que pueda figurar en el futuro, tanto la aplicación como el sitio web
        antes señalados son propiedad de WSP, rol único tributario número
        76.743.992-k, con domicilio en Av. Estoril 200, oficina 620, Las Condes,
        Santiago, Chile y dirección de e-mail info.chile@wesmartpark.com.
      </p>
      <p>
        Se deja constancia que la aplicación está dirigida exclusivamente a
        Usuarios residentes y/o domiciliados en Chile. Los Usuarios que no
        residan o que no se encuentren domiciliados en Chile y accedan y/o
        utilicen la aplicación de WSP en Chile lo harán bajo su responsabilidad
        y riesgo exclusivo.
      </p>
      <p>
        Al momento en que el Usuario accede y utiliza la aplicación y/o la
        página web
        <a href="https://www.wesmartpark.com" target="blank"
          >https://ww.wesmartpark.com</a
        >
        reconoce que ha leído y aceptado estos términos y condiciones generales
        de uso y se compromete a cumplir con todos sus términos y condiciones.
      </p>
      <p>
        Adicionalmente se deja constancia que el Usuario reconoce y acepta que
        el acceso y uso de la aplicación y del sitio web de WSP estarán sujetos
        a los términos y condiciones generales de uso que se encuentren vigentes
        en el momento en que acceda a ellos.
      </p>
      <p>
        Wesmartpark Chile SpA se reserva el derecho exclusivo de modificar en
        cualquier momento los presentes términos y condiciones generales de uso,
        respetando las normas aplicables que regulan el consumo de bienes y
        servicios en Chile, así como cualesquiera otras condiciones generales o
        particulares que resulten aplicables.
      </p>
      <p>
        Wesmartpark Chile SpA se reserva el derecho de suspender, interrumpir o
        dejar de operar la aplicación y/o el sitio web de WSP en cualquier
        momento. La prestación de los Servicios de WeSmartPark y el uso de la
        aplicación y página web de Wesmartpark está limitado a mayores de 18
        años que tengan licencia de conducir vigente que pueda ser factible de
        uso en Chile. En general, el Usuario podrá acceder a la aplicación y/o
        el sitio web de Wesmartpark libremente y de forma gratuita.
      </p>
      <p>
        Para estos efectos, el Usuario reconoce y acepta que el acceso y uso de
        la aplicación y/o del sitio web de Wesmartpark y de los Servicios de
        WeSmartPark lo realiza de forma libre y conscientemente, bajo su
        exclusiva responsabilidad. De esta forma, Wesmartpark Chile SpA no será
        en ningún caso responsable del uso que el Usuario y/o terceros pudieran
        hacer de la aplicación y/o sitio web de Wesmartpark, ni de los daños y/o
        perjuicios que pudieran derivarse del mismo. El Usuario se compromete a
        hacer un uso adecuado y lícito de la aplicación, del sitio web de
        Wesmartpark y de los Servicios de WeSmartPark, de conformidad con la
        legislación aplicable, los presentes términos y condiciones generales de
        uso, la moral y buenas costumbres generalmente aceptadas y el orden
        público.
      </p>
      <p>
        El Usuario deberá abstenerse de (a) hacer un uso no autorizado o
        fraudulento de la aplicación, del sitio web de Wesmartpark y/o de los
        Servicios de WeSmartPark; (b) acceder o intentar acceder a recursos
        restringidos de la aplicación, del sitio web de Wesmartpark y/o de los
        Servicios de WeSmartPark; (c) utilizar la aplicación, del sitio web de
        Wesmartpark y/o los Servicios de WeSmartPark con fines o efectos
        ilícitos, ilegales, contrarios a lo establecido en los presentes
        términos y condiciones generales de uso, a la buena fe y al orden
        público, lesivos de los derechos e intereses de terceros, o que de
        cualquier forma puedan dañar, inutilizar o sobrecargar o impedir la
        normal utilización o disfrute de la aplicación, del sitio web de
        Wesmartpark y/o los Servicios de WeSmartPark; (d) hacer uso de manera
        fraudulenta de beneficios que entrega plataforma Wesmartpark, como por
        ejemplo manipular datos y crear usuarios de forma incompleta o sin datos
        validados con la finalidad de obtener saldos gratis (e) provocar daños a
        la aplicación, del sitio web de Wesmartpark y/o los Servicios de
        WeSmartPark, o en los sistemas de sus proveedores, en los
        Estacionamientos, en los inmuebles de los Propietarios o de terceros;
        (f) introducir o difundir virus informáticos o cualesquiera otros
        sistemas físicos o lógicos que sean susceptibles de provocar daños en
        los sistemas de Wesmartpark, de sus proveedores o de terceros, (g)
        intentar acceder, utilizar y/o manipular los datos de Wesmartpark Chile
        SpA, terceros, Propietarios y/u otros Usuarios; (h) reproducir o copiar,
        distribuir, permitir el acceso del público a través de cualquier
        modalidad de comunicación pública, transformar o modificar los
        contenidos de la aplicación, del sitio web de Wesmartpark y/o los
        Servicios de WeSmartPark, a menos que se cuente con la autorización del
        titular de los correspondientes derechos o ello esté legalmente
        permitido; (i) obtener o intentar obtener los contenidos de la
        aplicación, del sitio web de WSP y/o los Servicios de WeSmartPark
        empleando para ello medios o procedimientos distintos de los que, según
        los casos, se hayan puesto a su disposición a este efecto. El Usuario
        únicamente podrá acceder a la aplicación, del sitio web de Wesmartpark
        y/o los Servicios de WeSmartPark a través de los medios autorizados por
        Wesmartpark Chile SpA. Es responsabilidad del Usuario asegurarse de que
        ha descargado la aplicación de Wesmartpark correcta en su dispositivo
        móvil. Wesmartpark Chile SpA no será responsable en caso de que el
        Usuario no disponga de un dispositivo compatible o haya descargado una
        versión de la aplicación de Wesmartpark incompatible con su dispositivo.
      </p>
      <p class="mb-0 mt-3">
        La aceptación de este documento implica que el Usuario:
      </p>
      <ul>
        <dl>a) Ha leído lo expuesto a continuación y lo comprende;</dl>
        <dl>
          b) Es una persona con capacidad suficiente para contratar y consiente
          en hacerlo; y
        </dl>
        <dl>c) Asume todas las obligaciones enumeradas en este instrumento.</dl>
      </ul>
      <br />
      <h2 class="mt-5 primary--text">1. Objeto:</h2>
      <p>
        Wesmarpark prestará al Usuario los servicios descritos en el “Anexo de
        Servicios y Condiciones de Uso” que se incorpora al presente instrumento
        y que forma parte integrante del mismo para todos los efectos a que haya
        lugar. El inicio de la prestación de los servicios estará condicionado
        al registro y creación de un Perfil del Usuario en las plataformas de
        Wesmartpark, sea en su sitio web y/o en la aplicación.
      </p>
      <p>
        A modo resumen y sin que ello limite en ninguna forma el “Anexo de
        Servicios y Condiciones de Uso”, a través de la aplicación el Usuario
        realizará reservas de uno o más Estacionamientos para estacionar su
        vehículo habilitado con StickerTag o a través de la tecnología Bluetooth
        de su teléfono móvil, cuyo uso pagará mediante la aplicación.
      </p>
      <p>
        Se deja constancia que Wesmartpark actúa en calidad de intermediario en
        la prestación de los servicios objeto de este instrumento y descritos en
        el “Anexo de Servicios y Condiciones de Uso”.
      </p>
      <h2 class="mt-5 primary--text">
        2. Precios: Reservas, Abonos y Saldos de los Usuarios.
      </h2>
      <p>
        El Usuario pagará el precio del servicio resultante de la aplicación de
        las tarifas vigentes en cada momento de acuerdo con las condiciones de
        uso del Estacionamiento de que se trate. El Usuario tendrá conocimiento
        de los precios y tarifas vigentes, las que constan en este documento,
        que, junto con sus modificaciones, son parte integrante del mismo. La
        modificación de los precios y tarifas de los servicios, aplicables
        tendrá lugar a través de la web de WeSmartPark:
        <a href="https://www.wesmartpark.com" target="blank"
          >https://ww.wesmartpark.com</a
        >
        y la información relativa a éstas podrá obtenerse, igualmente, en
        teléfono de atención al cliente +56 9 3186 0329. La modificación de
        tarifas nunca podrá aplicarse con carácter retroactivo, es decir, a
        reservas realizadas con anterioridad a la publicación de la
        modificación.
      </p>
      <h3>2.1. Precios, Tarifas y Abonos.</h3>
      <h4>Tarifa por minuto.</h4>
      <p>
        El Usuario pagará el precio del servicio resultante de la aplicación de
        las tarifas vigentes en cada momento de acuerdo con las condiciones
        vigentes de uso del mismo.
      </p>
      <p class="mb-0 mt-3">
        Desde el 01 de enero 2019 las tarifas WSP serán las siguientes:
      </p>
      <ul>
        <li>Precio por minuto: desde $20, IVA incluido.</li>
      </ul>
      <p class="mt-3">
        La modificación de tarifas nunca podrá aplicarse con carácter
        retroactivo, es decir, a reservas realizadas con anterioridad a la
        publicación de la modificación.
      </p>
      <h4>Penalización del Servicio: Tiempo Extra.</h4>
      <p>
        El servicio prestado por Wesmartpark corresponde a una red de
        Estacionamientos colaborativos. La propiedad de los Estacionamientos
        corresponde a sus Propietarios, lo que en ocasiones limita la
        disponibilidad de plazas de Estacionamientos para los Usuarios. Durante
        el proceso de Reserva un Usuario tendrá la información correspondiente a
        la posibilidad de que un Estacionamiento tenga o no asociada una
        limitación horaria respecto de su uso. El Usuario deberá marcar en una
        casilla un “check” conforme ha entendido que de no retirar el vehículo
        mediante el cual ha utilizado el servicio tras el Tiempo Límite, el
        Tiempo Adicional que esté, pasará a cobrarse al doble del valor por
        minuto informado en la App; por ejemplo si un parking tiene un valor por
        minuto de $20/min el usuario pasará a pagar en Tiempo adicional un valor
        de 40 $/min (IVA incluido).
      </p>
      <p>
        Frente a cualquier cargo o penalización que el Usuario considere
        errónea, éste puede ponerse en contacto con Wesmartpark por cualquiera
        de los medios habilitados para ello.
      </p>
      <h4>Tarifa por abonos.</h4>
      <p>
        El usuario que requiera utilizar un Estacionamiento durante un periodo
        de tiempo prolongado, según las tipologías de abonos que se singularizan
        a continuación, puede contratar el llamado “Abono” desde su web o en la
        aplicación de WSP, para lo cual el Usuario podrá requerir apoyo en la
        compra vía telefónica, llamando a atención al cliente +56 9 3186 0329.
        La disponibilidad de los abonos está sujeta a la aprobación del parking
        y a la disponibilidad del día y hora solicitados.
      </p>
      <p>
        Los abonos se pagan por el Usuario en el momento de su contratación, no
        son reembolsables y no pueden pagarse con el saldo corriente del
        Usuario, por lo que para su pago se realiza una compra específica por el
        valor final del abono. Los precios que constan son con IVA incluido.
      </p>
      <p>
        En el caso de que algún usuario entre al parking en un rango de hasta 30 
        minutos previo al inicio del abono tomado, el sistema cobrará este periodo 
        previo al inicio del abono el valor por minuto que tiene el parking informado 
        en la App. Para el caso de usuarios que salgan de su abono posterior al 
        tiempo límite de este abono, el sistema cobrará el tiempo adicional (es decir, 
        el tiempo posterior a la hora de término del abono) al valor por minuto 
        informado por el parking respectivo en la App hasta el momento de su salida del parking.
      </p>
      <p class="mb-0 mt-3">Tipologías de abonos:</p>
      <ul>
        <li>
          Abonos nocturnos, consistentes en el servicio de estacionamiento a ser
          utilizado por un Usuario de20:00 horas un día hasta las 08:00 horas
          del día siguiente.
        </li>
        <li>
          Abonos 24 horas, consistentes en el servicio de estacionamiento a ser
          utilizado por un Usuario por ejemplo desde las 19:00 horas de un día
          hasta las 18:00 horas del día siguiente.
        </li>
        <li>
          Abonos 1 semana, consistentes en el servicio de estacionamiento a ser
          utilizado por un Usuario por ejemplo desde las 15:00 horas del día
          lunes correspondiente hasta las 14:00 horas del día domingo
          inmediatamente siguiente al lunes de ingreso.
        </li>
        <li>
          Abonos Tope Día, consistentes en el servicio de estacionamiento a ser
          utilizado por un Usuario por ejemplo desde las 10:00 horas de un día
          hasta las 23:59 horas del mismo día.
        </li>
        <li>
          Abonos “x” Días, consistentes en el servicio de estacionamiento a ser
          utilizado por un Usuario por “x” cantidad de días calendario.
        </li>
      </ul>
      <p class="mt-3">
        Para consultar precios y disponibilidades de abonos en cada
        Estacionamiento en particular, el Usuario deberá consultar el menú
        abonos de la aplicación y/o la página web de Wesmartpark.
      </p>
      <h3>2.2. Saldos de Usuarios.</h3>
      <p>
        Se entenderá por saldo del Usuario el dinero asociado al Perfil del
        Usuario que se utiliza para pagar las reservas por minuto realizadas en
        los Estacionamientos de la red Wesmartpark ofrecidos en la aplicación o
        en la página web, el saldo se puede recargar desde la aplicación o la
        página web mediante la compra de “paquetes de horas” asociando una
        tarjeta de crédito o débito al sistema, dado que las cargas y recargas
        sólo pueden ser realizadas mediante tarjeta de crédito o débito,
        pudiendo utilizarse sólo las tarjetas de crédito o débito que operan por
        el sistema Transbank. El Usuario sólo podrá realizar recargas mediante
        la compra de “Packs”, los que corresponden a: a) Pack Pequeño,
        correspondiente a $5.000, el que sólo puede ser comprado una sola vez
        por el Usuario, y luego deja de estar disponible, b) Pack Pequeño:
        correspondiente a $10.000, c) Pack Mediano, correspondiente a $20.000 y
        d) Pack Grande, correspondiente a $40.000.
      </p>
      <p>
        Una vez realizada una o más cargas de saldo por el Usuario, éste
        recibirá una boleta en su correo electrónico registrado en su Perfil,
        boleta que reflejará por el importe exacto de la carga de saldo
        mencionada anteriormente. En caso de que el Usuario requiera la emisión
        de factura, éste puede solicitarla enviando un email con sus datos
        fiscales a
        <a href="mailto:info.chile@wesmartpark.com"
          >info.chile@wesmartpark.com</a
        >.
      </p>
      <p>
        Wesmartpark empezará a cobrar (descontar de saldo del Usuario) en el
        momento en que el StickerTag o sistema BLE accede a los Estacionamientos
        y finaliza cuando éste los abandona, cobrándosele así los minutos
        exactos que el Usuario está estacionado en el Estacionamiento. El cobro
        se realizará directamente desde el saldo disponible del Usuario, cobro
        que corresponderá exactamente al importe equivalente a los minutos en
        que el Usuario hizo uso de los Estacionamientos. En el caso de los
        Abonos (en sus diferentes formatos) el cobró se realizará al momento de
        comprar y se realizará mediante un cargo a su tarjeta de crédito o
        débito, pudiendo utilizarse sólo las tarjetas de crédito o débito que
        operan por el sistema Transbank.
      </p>
      <p>
        El Usuario dispone de un registro de uso de los Estacionamientos que ha
        utilizado, lo cual puede ser consultado por este en su Perfil en la
        aplicación o en la página web de WSP.
      </p>
      <h3>2.3. Saldos negativos.</h3>
      <p>
        En el caso de que un Usuario haya hecho uso de los servicios objeto de
        este instrumento y al de salir de un Estacionamiento no cuente con saldo
        suficiente para abonar la totalidad de la reserva realizada, el sistema
        operativo del Servicio WeSmartPark dejará salir al Usuario del
        Estacionamiento, cobrará el importe del Estacionamiento utilizado hasta
        finalizar el saldo existente, y el monto restante lo dejará en
        “negativo” en el perfil del Usuario a la espera de que el Usuario
        realice su próxima recarga. En dicha recarga el sistema cobrará
        automáticamente el saldo negativo del Usuario.
      </p>
      <h4>2.3.1. Condiciones de los saldos negativos.</h4>
      <ul>
        <li>
          Límite de tiempo para mantener un saldo negativo: Wesmartpark
          establece un periodo máximo de 3 meses para que un Usuario pueda
          permanecer en su perfil con saldo negativo. Si tras haber enviado las
          comunicaciones informativas al Usuario (comunicaciones que en todo
          caso son facultativas para WSP) indicando el importe del saldo y
          reclamando la recarga y haberse cumplido el periodo máximo de 3 meses
          en que el Usuario puede tener su perfil con saldo negativo y el
          Usuario de todas formas no actualizara su saldo, pagando la totalidad
          del saldo negativo pendiente, Wesmartpark se reserva el derecho, pero
          no la obligación, de dar de baja al Usuario y tomar las medidas
          legales aplicables para reclamar el importe adeudado.
        </li>
        <li>
          Importe máximo de saldo negativo: WSP establece como importe límite
          para saldos negativos aquellos que sean iguales o superiores a $5.000.
          En el caso de que un usuario llegue a acumular $5.000 o mayor deuda en
          su saldo, Wesmartpark solicitará por escrito al Usuario, al email
          registrado en su Perfil, el pago de la misma. Para estos efectos el
          Usuario dispondrá de un plazo máximo de 72 horas para realizar la
          recarga de su saldo. En caso de no hacerlo, el Usuario podrá ser dado
          de baja del sistema por Wesmartpark y Wesmartpark Chile SpA podrá
          tomar las medidas legales aplicables para reclamar el importe
          adeudado.
        </li>
      </ul>
      <h2 class="mt-5 primary--text">3. Saldo y Pago.</h2>
      <p>
        El Usuario deberá realizar la carga por adelantado, de forma tal que el
        pago por el uso de los Estacionamientos sólo se podrá materializar una
        vez cargado su saldo a través de su Perfil. El saldo en pesos quedará
        guardado en el Perfil de Usuario. El saldo podrá ser consultado y
        ampliado por el Usuario a través de la aplicación de WSP. A medida que
        el usuario utiliza los Estacionamientos, el dinero de su saldo se va
        reduciendo por cada minuto de aparcamiento en función de la tarifa
        aplicable de acuerdo con las condiciones de uso. Para poder realizar una
        reserva en el Servicio WeSmartPark, será condición indispensable que el
        usuario disponga, como mínimo, de $1 positivo. En el caso de que un
        usuario salga de un Estacionamiento y su saldo no sea suficiente para
        pagar los minutos aparcados el sistema cobrará hasta donde el saldo del
        cliente le permita y la parte en negativo será descontada
        automáticamente en la próxima recarga de saldo del Usuario.
      </p>
      <h2 class="mt-5 primary--text">4. Devolución de saldo.</h2>
      <p>
        El usuario tendrá derecho a la devolución de Saldo únicamente cuando se
        cumplan las siguientes condiciones: (1) Que el cliente haya realizado un
        importe, (2) Que el cliente no haya utilizado la aplicación y los
        diferentes productos que esta entrega y, (3) Que entre la aceptación de
        estos términos y condiciones, y la solicitud de baja de Perfil no hayan
        transcurrido más de 10 días. En el caso que sea procedente la devolución
        señalada precedentemente, el monto devuelto no incluirá el saldo
        gratuito de bienvenida que otorga Wesmartpark Chile SpA.
      </p>
      <p>
        De no cumplir las condiciones estipuladas, no será procedente la
        devolución de Saldo en caso alguno.
      </p>
      <h2 class="mt-5 primary--text">5. Solicitud de baja.</h2>
      <p>
        El Usuario podrá solicitar a Wesmartpark Chile SpA, en cualquier
        momento, la baja de su Perfil. Los Usuarios que estén interesados en
        darse de baja deberán ponerlo en conocimiento de Wesmartpark Chile SpA a
        través de los medios que la empresa pone a disposición del Usuario
        dentro de su Perfil. La solicitud de baja supone la pérdida, sin
        restitución, del importe abonado a WSP Chile en concepto de saldo en
        pesos que pudiera mantener en ese momento, teniendo en consideración que
        el Usuario no podrá ser dado de baja mientas mantuviera saldo negativo
        en su Perfil.
      </p>
      <h2 class="mt-5 primary--text">
        6. Qué puede esperar el Usuario en caso de fallos en el servicio no
        atribuibles a Wesmartpark.
      </h2>
      <p>
        Si debido a una utilización indebida, ya sea por parte de Usuarios y/o
        de Propietarios, Wesmartpark no pudiere mantener la reserva efectuada
        por el Usuario afectado, éste será informado por la empresa con a través
        de un mensaje de texto a su teléfono celular registrado en su Perfil o
        SMS, al email registrado en su Perfil y/o mediante notificaciones Push
        en la aplicación móvil de Wesmartpark. Wesmartpark Chile SpA asume la
        obligación de proporcionar al Usuario, a la mayor brevedad, la
        posibilidad de realizar otra reserva de características lo más similares
        posibles a sus requisitos de búsqueda inicial, liberando desde ya el
        Usuario afectado a Wesmartpark de cualquier responsabilidad al respecto.
      </p>
      <p>
        En el supuesto anterior, la reserva inicial quedará automáticamente
        anulada, y la o las nuevas propuestas de reserva efectuadas por WSP al
        Usuario afectado no se entenderán como aceptadas hasta que el Usuario no
        formalice y confirme la nueva reserva de manera expresa a través de los
        medios que a tal efecto se le proporcionan mediante la aplicación o la
        página web de Wesmartpark.
      </p>
      <h2 class="mt-5 primary--text">7. Obligaciones de WSP.</h2>
      <p class="mb-0">
        Wesmartpark, en la prestación del Servicio WeSmartPark, asume ante el
        Usuario las siguientes obligaciones:
      </p>
      <ol type="a">
        <li>
          Prestar los servicios, de acuerdo con las presentes condiciones de
          uso, y emplear todos los medios necesarios para el restablecimiento de
          éstos, cuando se vean interrumpidos por un fallo a ella imputable.
        </li>
        <li>
          Informar al Usuario, con un mes de antelación, de la variación de las
          condiciones de prestación de los servicios. De manera específica,
          aparecerán en la web las tarifas actuales, y si van a ser objeto de
          modificación las nuevas, con un mes de antelación como mínimo, a su
          entrada en vigor. Cualquier otro cambio en las condiciones del
          presente instrumento tendrá, asimismo, una publicidad en los canales
          sociales de Wesmartpark (redes sociales, web y newsletter) durante un
          mes antes de aplicarse.
        </li>
        <li>
          Garantizar el secreto de los datos personales de los Usuarios. No
          obstante, Wesmartpark Chile SpA quedará exonerada de responsabilidad,
          si la obtención de datos por un Usuario o terceros, se produce como
          consecuencia de actos que no les sean atribuibles a su culpa y/o dolo,
          o puedan obtenerse a través de procesos que se encuentran fuera del
          control que pueda llevar a cabo WSP.
        </li>
        <li>
          Facilitar al Usuario las aclaraciones que éste solicite en cuanto a
          las condiciones del servicio, facturación y las condiciones esenciales
          del contrato.
        </li>
      </ol>
      <h2 class="mt-5 primary--text">8. Obligaciones del usuario.</h2>
      <p class="mb-0">
        La utilización del Servicio WeSmartPark por el Usuario supone la
        asunción de las siguientes obligaciones:
      </p>
      <ol type="a">
        <li>
          Tenencia de un teléfono móvil operativo durante la utilización del
          Servicio WeSmartPark. Necesariamente se corresponderá con el número
          facilitado por el Usuario al registrarse como tal en su Perfil. A
          efecto de poder recibir las notificaciones del servicio, el Usuario se
          obliga de manera especial a dar cumplimiento durante su uso del
          Servicio WeSmartPark a esta obligación.
        </li>
        <li>
          El Usuario se compromete a que el vehículo que utilice para hacer
          efectivos los Servicios de WeSmartPark siempre tenga correctamente
          instalada la etiqueta o StickerTag, de acuerdo a sus instrucciones de
          instalación que se le comunicaron al momento de la entrega del
          referido StickerTag.
        </li>
        <li>
          Por otra parte el Usuario que acceda con tecnología Bluetooth a los
          estacionamientos se compromete a que para hacer efectivos los
          Servicios de WeSmartPark siempre tenga habilitado el sistema de
          Bluetooth de su teléfono móvil, de acuerdo a sus instrucciones de
          instalación que se le comunicaron al momento de su activación en WSP.
        </li>
        <li>
          El Usuario se compromete a respetar los tiempos de entrada y salida de
          los Estacionamiento, en el caso de que hubiera limitación horaria,
          tiempos que serán especificados en el detalle de información que cada
          parking tiene en su detalle; de no hacerlo, asume el pago de las
          tarifas adicionales o penalidades especificadas en el presente
          instrumento.
        </li>
        <li>
          El Usuario se compromete a hacer un buen uso de las instalaciones de
          los Estacionamientos por lo que no podrá causar molestias, estorbos, o
          daños en los inmuebles en que los Estacionamientos se encuentren
          ubicados, siendo responsable de los daños y/o perjuicios que pudiera
          causar tanto en la estructura del establecimiento, en el mobiliario
          y/o otros vehículos o personas, liberando desde ya a Wesmartpark Chile
          SpA de cualquier responsabilidad al respecto, y, facultando desde ya a
          Wesmartpark Chile SpA para cargar cualquier importe o pago adicional a
          la tarifa por el servicio prestado, en atención a los daños causados.
        </li>
        <li>
          El Usuario es responsable de la veracidad de los datos y de la
          información facilitada durante su registro en el Perfil.
        </li>
      </ol>
      <h2 class="mt-5 primary--text">9. Modificaciones en los servicios.</h2>
      <p>
        La modificación por Wesmartpark Chile SpA de las condiciones de uso de
        los Servicios de WeSmartPark facultará al Usuario a darse de baja; lo
        que tendrá lugar sin perjuicio de la exigibilidad de cumplimiento, por
        ambas partes, de las obligaciones vigentes, que hayan surgido con
        anterioridad a la solicitud de baja.
      </p>
      <h2 class="mt-5 primary--text">10. Reclamos.</h2>
      <p>
        El Usuario podrá formular sus quejas o reclamos mediante los formularios
        oficiales que Wesmartpark Chile SpA tiene a su disposición a través del
        correo
        <a href="mailto:info.chile@wesmartpark.com"
          >info.chile@wesmartpark.com</a
        >.
      </p>
      <h2 class="mt-5 primary--text">11. Protección de datos.</h2>
      <p>
        Wesmartpark Chile SpA garantiza la confidencialidad de los datos de
        carácter personal e informa a sus Usuarios que los datos facilitados por
        los mismos quedan incorporados a un fichero de Wesmartpark, cuya única
        finalidad es proceder al mantenimiento, administración, ampliación,
        mejora y gestión de la relación con el Usuario. Wesmartpark podrá
        utilizar los citados datos de carácter personal para solicitar
        información sobre la solvencia del Usuario. Así mismo Wesmartpark podrá
        ceder a terceros los datos de carácter personal cuando sea necesario
        para la correcta prestación del servicio, por lo que el Usuario presta
        desde ya expreso consentimiento al respecto, o para resolver cualquier,
        reclamo, queja o demanda de otro Usuario o persona que, teniendo las
        pruebas suficientes que lo acrediten, involucre la participación del
        Usuario en cuestión en algún hecho que motive el referido reclamo, queja
        o demanda.
      </p>
      <p>
        Los datos de carácter personal de los Usuarios contenidos en el fichero
        de Wesmartpark se utilizarán respetando las disposiciones contempladas
        por la Ley N° 19.628 sobre Protección de la Vida Privada y cualquier
        otra normativa que la complemente, modifique o sustituya. El Usuario,
        cuando no manifieste su oposición en el proceso de registro de su
        Perfil, autoriza de forma expresa a WSP Chile, u otra empresa de su
        grupo, para que ésta, pueda remitirle información sobre productos y
        servicios de movilidad sostenible.
      </p>
      <p>
        Cualquier otra utilización de los datos de carácter personal del Usuario
        contenidos en el referido fichero de WSP, requerirá informar expresa y
        previamente al Usuario y de su autorización expresa y por escrito.
      </p>
      <h2 class="mt-5 primary--text">
        12. Derechos de Propiedad Intelectual e Industrial.
      </h2>
      <p>
        El Usuario reconoce y acepta que todos los derechos de propiedad
        intelectual e industrial sobre los contenidos y/o cualesquiera otros
        elementos insertados en la aplicación, del sitio web de Wesmartpark y/o
        de los Servicios de WeSmartPark (incluyendo, sin limitación, marcas,
        logotipos, nombres comerciales, textos, imágenes, gráficos, diseños,
        sonidos, bases de datos, software, diagramas de flujo, presentación,
        audio y vídeo), pertenecen a Wesmartpark. Wesmartpark autoriza al
        Usuario a utilizar, visualizar, imprimir, descargar y almacenar los
        contenidos y/o los elementos insertados en la aplicación y/o en sitio
        web de WSP exclusivamente para su uso personal, privado y no lucrativo,
        absteniéndose de realizar sobre los mismos cualquier acto de
        descompilación, ingeniería inversa, modificación, divulgación o
        suministro. Cualquier otro uso o explotación de cualesquiera contenidos
        y/u otros elementos insertados en la aplicación y/o en el sitio web de
        WSP distinto de los aquí expresamente previstos estará sujeto a la
        autorización previa de WSP Chile.
      </p>
      <h2 class="mt-5 primary--text">13. Responsabilidad.</h2>
      <p>
        Wesmartpark Chile SpA no garantiza la disponibilidad y continuidad del
        funcionamiento de la aplicación y/o del sitio web de Wesmartpark. En
        consecuencia, Wesmartpark no será en ningún caso responsable por
        cualesquiera daños y perjuicios que puedan derivarse de (a) la falta de
        disponibilidad o accesibilidad a la aplicación y/o del sitio web de
        Wesmartpark; (b) la interrupción en el funcionamiento de la aplicación
        y/o del sitio web de Wesmartpark o fallos informáticos, averías
        telefónicas, desconexiones, retrasos o bloqueos causados por
        deficiencias o sobrecargas en las líneas telefónicas, centros de datos,
        en el sistema de Internet o en otros sistemas electrónicos, producidos
        en el curso de su funcionamiento; y (c) otros daños que puedan ser
        causados por terceros mediante intromisiones no autorizadas ajenas al
        control de Wesmartpark. Wesmartpark Chile SpA no garantiza la ausencia
        de virus ni de otros elementos en la aplicación y/o del sitio web de WSP
        introducidos por terceros ajenos a WSP que puedan producir alteraciones
        en los sistemas físicos o lógicos del Usuario o en los documentos
        electrónicos y ficheros almacenados en sus sistemas. En consecuencia,
        Wesmartpark Chile SpA no será responsable en ningún caso de cualquier
        daño y/o perjuicio de toda naturaleza que pudieran derivarse de la
        presencia de virus u otros elementos que puedan producir alteraciones en
        los sistemas físicos o lógicos, documentos electrónicos o ficheros del
        Usuario. Wesmartpark Chile SpA adopta diversas medidas de protección
        para proteger la aplicación y/o del sitio web de WSP y los contenidos
        contra ataques informáticos de terceros. No obstante, Wesmartpark no
        garantiza que terceros no autorizados no puedan conocer las condiciones,
        características y circunstancias en las cuales el Usuario accede a la
        aplicación y/o del sitio web de Wesmartpark. En consecuencia,
        Wesmartpark Chile no será en ningún caso responsable de los daños y/o
        perjuicios que pudieran derivarse de dicho acceso no autorizado. Con la
        suscripción de los presentes términos y condiciones generales de uso, el
        Usuario declara que mantendrá indemne frente a cualquier reclamación a
        WSP Chile, su sociedad matriz, directores, accionistas, socios,
        empleados, abogados y agentes, de hechos que le sean imputables
        derivados del (i) incumplimiento por parte del Usuario de cualquier
        disposición contenida en los presentes términos y condiciones generales
        de uso o de cualquier ley o regulación aplicable a las mismas, (ii)
        incumplimiento o violación de los derechos de terceros incluyendo, a
        título meramente enunciativo, los terceros transportistas, otros
        conductores y peatones; y (iii) incumplimiento del uso permitido de la
        aplicación y/o sitio web de Wesmartpark. En caso de que, una vez
        procesada la reserva por parte del Usuario, el Propietario no deje
        ingresar al Usuario al inmueble en donde consten los Estacionamientos,
        el Usuario podrá ponerse en contacto con Wesmartpark para que, en la
        medida de lo posible, ésta proporcione al Usuario una solución
        alternativa a su reserva según se indicó precedentemente en estos
        términos y condiciones generales de uso.
      </p>
      <h2 class="mt-5 primary--text">14. Cesión.</h2>
      <p>
        El Usuario no podrá ceder sus derechos y obligaciones que emanen de los
        presentes términos y condiciones generales de uso sin el previo
        consentimiento escrito de Wesmartpark Chile SpA. Wesmartpark Chile SpA
        podrá ceder, sin necesidad de recabar el consentimiento previo del
        Usuario, los presentes términos y condiciones generales de uso a
        cualquier entidad comprendida dentro de su grupo de sociedades, en todo
        el mundo, así como a cualquier persona o entidad que le suceda en el
        ejercicio de su negocio por cualesquiera títulos.
      </p>
      <h2 class="mt-5 primary--text">15. Ley Aplicable y Jurisdicción</h2>
      <p>
        El presente instrumento, así como la relación entre Wesmartpark Chile
        SpA y el Usuario, se regirán e interpretarán con arreglo la ley chilena.
        Las partes acuerdan que, conforme a la Ley de Protección al Consumidor,
        el Usuario (consumidor) que desee ejercer acciones legales contra
        Wesmartpark, podrá hacerlos ante el Juzgado de Policía Local de (i)
        lugar donde se celebró o ejecutó el acto o contrato, (ii) domicilio del
        proveedor, o (iii) domicilio del consumidor, a su elección. Es decir, el
        Usuario siempre puede elegir en cual de esos tres territorios ejercerá
        su acción.
      </p>
      <h1 class="mt-5 primary--text">
        Anexo de servicios y condiciones de uso.
      </h1>
      <h2 class="mt-5 primary--text">Definición del Servicio.</h2>
      <p>
        Wesmartpark es un servicio de parksharing o estacionamiento compartido.
        El Servicio WeSmartPark ofrece al Usuario la posibilidad, partiendo de
        sus necesidades o preferencias concretas respecto a lugar, fecha y hora
        de entrada; de reservar un espacio destinado a estacionar su vehículo en
        los Estacionamientos de la red de Wesmartpark, cuya titularidad ostenta
        un tercero, el Propietario.
      </p>
      <h2 class="mt-5 primary--text">
        Procedimiento de Alta, Contratación y Condiciones de Uso del Servicio.
      </h2>
      <p>
        Para poder acceder a los servicios que ofrece el dominio
        <a href="https://www.wesmartpark.com" target="blank"
          >https://ww.wesmartpark.com</a
        >, el Usuario se debe dar de alta en el sitio web de WSP mediante la
        creación de un Perfil; para hacerlo, el Usuario ha de proporcionar de
        forma libre, voluntaria y veraz los datos personales que se le pidan.
      </p>
      <p>
        El Usuario debe escoger un nombre de usuario y una contraseña, y se
        compromete a hacer un uso diligente y no ponerlos a disposición de
        terceros, así como de comunicar a Wesmartpark Chile SpA su pérdida, robo
        o posibles accesos por parte de terceros no autorizados, a fin de que
        Wesmartpark Chile SpA proceda al bloqueo inmediato de dicho Perfil. El
        Usuario puede escoger como nombre de usuario un correo electrónico de su
        propiedad que pueda ser verificado por Wesmartpark Chile SpA.
      </p>
      <p class="mb-0 mt-3">El proceso de alta de Usuario es el siguiente:</p>
      <ol>
        <li>
          El Usuario inicia su registro a través del dominio
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >; para ello introduce los datos requeridos en el proceso (Email,
          contraseña y número de móvil). Al momento de realizar la primera
          recarga de saldo deberán incorporarse los datos de la tarjeta de
          crédito asociada, la que deberá corresponder a una tarjeta de crédito
          que opere por el sistema Transbank.
        </li>
        <li>
          El usuario recibe un PIN en el móvil facilitado que deberá introducir
          durante el proceso de registro para que Wesmartpark valide que éste es
          de su propiedad.
        </li>
        <li>
          El Usuario podrá adquirir su Stickertag en cualquier tienda disponible
          en la sección “tiendas” de la App WSP (stock sujeto a disponibilidad
          en cada tienda) y tendrán un costo de $1.000 cada unidad.
        </li>
        <li>
          Una vez comprado el StickerTag el Usuario deberá activar dicho Sticker
          de acceso en su Perfil, introduciendo el código único e intransferible
          que en él viene, de esta forma el Wesmartpark asociará el StickerTag
          con el Usuario.
        </li>
        <li>
          El Usuario también podrá tener a su disposición Tecnología Bluetooth
          de su teléfono móvil para acceder a los estacionamientos sin la
          necesidad de tener que comprar un Stickertag. Este proceso de
          activación y validación de la información podrá tomar a lo menos
          24horas desde su registro, luego de este periodo el usuario recibirá
          una notificación Push al número de teléfono proporcionado durante el
          registro, para comunicarle que ya dispone de su acceso a la plataforma
          para usar la red de estacionamiento de WSP.
        </li>
        <li>
          El Usuario con tecnología Bluetooth deberá habilitar los vehículos que
          utiliza a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android e IOS;
          proporcionando un alias para su vehículo y su patente.
        </li>
        <li>
          El Usuario recibirá un saldo gratuito de bienvenida de $3.000 que
          deberá consumir en su totalidad en un periodo de 3 meses tras la fecha
          de activación de su perfil. En el caso de no haberlo consumido pasada
          la fecha anteriormente descrita Wesmartpark se reserva el derecho de
          retirar el saldo regalado definitivamente del Perfil del Usuario.
        </li>
        <li>
          Una vez hayan sido activados y validados los datos introducidos en el
          Perfil del Usuario el proceso de alta estará completo y el Usuario
          está listo para utilizar y contratar el Servicio WeSmartPark.
        </li>
      </ol>
      <p class="mb-0 mt-3">
        Después de crear el Perfil, el proceso de contratación del Servicio
        WeSmartPark seguirá los pasos descritos a continuación:
      </p>
      <ol>
        <li>
          El usuario, inicia sesión desde la aplicación de Wesmartpark o desde
          el sitio web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >.
        </li>
        <li>
          Una vez que el Usuario haya introducido su “login” y “password”, el
          Usuario deberá introducir la dirección de destino o deberá hacer
          “click” directamente encima del parking (identificado con la letra “P”
          en mapa) que le interesa.
        </li>
        <li>
          A continuación el Usuario deberá seleccionar la hora de entrada al
          Estacionamiento y deberá seleccionar el botón “Estacionar”, el sistema
          Wesmartpark le indicará en la pestaña “información” si existe una hora
          límite de salida para ese Estacionamiento. Luego el Usuario deberá
          marcar una casilla “Check” conforme entiende que ese Estacionamiento
          tiene una fecha límite.
        </li>
        <li>
          La reserva del Estacionamiento se confirma haciendo click sobre el
          botón “Estacionar”, al hacerlo aparecerá una ventana anunciando la
          confirmación de la reserva, que quedará archivada en el apartado “Mis
          reservas”, lugar donde el Usuario podrá acudir en el caso de querer
          cancelarla o editarla.
        </li>
      </ol>
      <p class="mb-0 mt-3">
        El proceso de recarga de saldo y consumo es el siguiente:
      </p>
      <ol>
        <li>
          El Usuario se dirige en la App o página
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >, a la opción “Cargar Saldo”, en ella aparecen varias opciones de
          compra:
          <ul>
            <dl>Pack Mini: $5.000</dl>
            <dl>Pack Pequeño: $10.000</dl>
            <dl>Pack Mediano: $20.000</dl>
            <dl>Pack Grande: $40.000</dl>
          </ul>
        </li>
        <li>
          El Usuario selecciona el Pack que más se ajusta a sus necesidades y
          hace click al botón “Comprar”.
        </li>
        <li>
          Se abre una ventana en dónde el Usuario introduce los datos de su
          tarjeta de crédito o débito, la que deberá corresponder a una tarjeta
          de crédito o débito que opere por el sistema Transbank para realizar
          la compra.
        </li>
        <li>
          Una vez realizada la compra ésta se carga en el saldo del Usuario, que
          puede corroborar en la sección “su saldo” de la aplicación.
        </li>
        <li>
          Cuando el Usuario hace uso de una reserva y sale del Estacionamiento,
          el sistema utilizado por Wesmartpark calcula los minutos que éste ha
          permanecido dentro del Estacionamiento y resta la cantidad del saldo
          exacta que corresponde al uso del Estacionamiento, el cálculo se
          realiza automáticamente gracias al StickerTag. En el caso de utilizar
          la plataforma con sistema Bluetooth el usuario deberá en cada ocasión
          que sale de un parking presionar el botón “Salida Vehicular” que se
          habilita en la reserva luego de 5 minutos transcurrido el acceso al
          estacionamiento.
        </li>
        <li>
          El Usuario no podrá realizar una reserva si su saldo está en negativo.
        </li>
      </ol>
      <p class="mb-0 mt-3">
        Uso mediante Tecnología de acceso Stickertag (RFID):
      </p>
      <ul>
        <li>
          Para poder acceder al estacionamiento el usuario deberá disponer de
          una Reserva o Abono válido y de las Tecnologías de acceso.
        </li>
        <li>
          Para dirigirse al estacionamiento WSP contratado, el usuario podrá
          usar el sistema de navegación a través de las aplicaciones móviles
          para sistemas operativos Android y iOS.
        </li>
        <li>
          Para acceder al estacionamiento WSP, el usuario debe aproximarse con
          su vehículo a la entrada del estacionamiento; al hacerlo, la luz de la
          antena WSP instalada parpadeará en verde, indicando que se está
          detectando el stickertag del usuario y se está consultando sus
          permisos de acceso.
        </li>
        <li>
          Si la luz se queda en verde fijo, la puerta se abrirá y pondrá su
          Reserva o Abono en uso. Si la luz se queda en rojo fijo, la puerta no
          se abrirá, significando que el usuario no dispone de una Reserva o
          Abono válido.
        </li>
        <li>
          Cuando el usuario acceda al interior del estacionamiento WSP, deberá
          seguir las indicaciones de cartelería para localizar la Zona WSP donde
          están ubicadas las plazas gestionadas por el servicio WSP y estacionar
          en una de ellas. En el caso que el estacionamiento tenga asignación de
          plaza, el usuario debe consultar la plaza asignada en la Pantalla de
          Control. Estacionar en una plaza no asignada o no gestionada por el
          servicio WSP puede conllevar la expulsión del servicio.
        </li>
        <li>
          Una vez estacionado el vehículo en la plaza WSP. El usuario podrá
          abandonar a pie el estacionamiento siguiendo las instrucciones de
          cartelería.
        </li>
        <li>
          Para recoger el vehículo del estacionamiento WSP, el usuario deberá
          seguir las indicaciones del detalle del estacionamiento; estas se
          pueden consultar en la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          Para salir del estacionamiento WSP el usuario deberá aproximarse a la
          salida del estacionamiento; al hacerlo la luz de la antena WSP
          instalada parpadeará en verde, indicando que se está detectando el
          stickertag del usuario.
        </li>
        <li>
          Si la luz se queda en verde fijo, la puerta se abrirá y pondrá su
          Reserva en cerrada. El consumo será deducido del Saldo del usuario, y
          se dará por finalizado el servicio contratado.
        </li>
      </ul>
      <p class="mb-0 mt-3">Uso mediante Tecnología de acceso Bluetooh:</p>
      <ul>
        <li>
          Para poder acceder al estacionamiento el usuario deberá disponer de
          una Reserva o Abono válido y de las Tecnologías de acceso.
        </li>
        <li>
          Para dirigirse al estacionamiento WSP contratado, el usuario podrá
          usar el sistema de navegación a través de la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          Para acceder al estacionamiento WSP, el usuario debe aproximarse con
          su vehículo a la entrada del estacionamiento con la aplicación WSP
          abierta y en primer plano, el servicio de geolocalización activado y
          el servicio de bluetooth activado.
        </li>
        <li>
          Al acercarse a la puerta, se detectará el bluetooth del usuario,
          indicando que se está consultando sus permisos de acceso. Si los
          permisos son correctos la puerta se abrirá automáticamente y la
          Reserva o Abono se pondrá en uso. En el caso de que la puerta no se
          abra automáticamente, el usuario podrá solicitar la apertura pulsando
          el botón “Entrada vehículo” en la pantalla de la aplicación móvil WSP.
        </li>
        <li>
          Cuando el usuario acceda al interior del estacionamiento WSP, deberá
          seguir las indicaciones de cartelería para localizar la Zona WSP donde
          están ubicadas las plazas gestionadas por el servicio WSP y estacionar
          en una de ellas. En el caso de que el estacionamiento tenga asignación
          de plaza, el usuario deberá consultar la plaza asignada en la
          aplicación móvil WSP. Estacionar en una plaza no asignada o no
          gestionada por el servicio WSP puede conllevar la expulsión del
          servicio.
        </li>
        <li>
          Una vez estacionado el vehículo en la plaza WSP. El usuario podrá
          abandonar a pie el estacionamiento siguiendo las instrucciones de
          cartelería.
        </li>
        <li>
          Para recoger el vehículo del estacionamiento WSP, el usuario deberá
          seguir las indicaciones del detalle del estacionamiento; estas se
          pueden consultar en la web
          <a href="https://www.wesmartpark.com" target="blank"
            >https://ww.wesmartpark.com</a
          >
          y sus aplicaciones móviles para sistemas operativos Android y iOS.
        </li>
        <li>
          Para salir del estacionamiento WSP el usuario deberá aproximarse a la
          salida del estacionamiento con la aplicación WSP abierta, el servicio
          de geolocalización activado y el servicio de bluetooth activado.
        </li>
        <li>
          Cuando el usuario este delante de la puerta de salida, deberá pulsar
          el botón “Salida Vehículo” en la pantalla de la aplicación móvil WSP.
          Al hacerlo, la puerta se abrirá y la Reserva se pondrá en cerrada. El
          consumo será deducido del Saldo del usuario, y se dará por finalizado
          el servicio contratado.
        </li>
      </ul>
      <p class="mb-0 mt-3">
        A fin de asegurar una mayor comprensión del uso del servicio,
        Wesmartpark Chile SpA ha habilitado en su web los siguientes enlaces y
        soportes de resolución de dudas:
      </p>
      <ul>
        <dl>
          <b>Video tutorial:</b>&nbsp;
          <a href="https://www.youtube.com/watch?v=KZkTSYJ4D18" target="_blank"
            >https://www.youtube.com/watch?v=KZkTSYJ4D18</a
          >
        </dl>
        <dl>
          <b>Preguntas frecuentes:</b>&nbsp;
          <a href="https://santiago.wesmartpark.com/es/ayuda" target="_blank"
            >https://santiago.wesmartpark.com/es/ayuda</a
          >
        </dl>
        <dl>
          <b>Línea atención telefónica:</b>
          <ul>
            <li>
              Lunes a Viernes entre las 8am y las 1920pm, en el teléfono +56
              931860329.
            </li>
          </ul>
        </dl>
      </ul>
    </v-container>
  </v-window>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'TermsOfUseChile',
  methods: {
    onWaypoint({ going, direction, el }) {
      if (going === this.$waypointMap.GOING_IN) {
        EventBus.$emit(keys.eventShowToolbar, { offset: el.offsetTop });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#landing-section {
  height: calc(100vh);
}
#landing-section #slogan {
  font-weight: bold;
}
.xs #landing-section #slogan {
  font-size: 4vh;
  line-height: 6vh;
}
.sm #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.md #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.lg #landing-section #slogan {
  font-size: 7vh;
  line-height: 7vh;
}

.xs #landing-section #subslogan {
  font-size: 2vh;
  line-height: 2vh;
}
.sm #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.md #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.lg #landing-section #subslogan {
  font-size: 4vh;
  line-height: 4vh;
}

#landing-section #landing-section-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
#landing-section .v-card {
  margin-top: -10%;
}
</style>
